import { AutogenLayoutAuthorizationStatusQuickInfo } from "./autogen/AutogenLayoutAuthorizationStatusQuickInfo";

export class AuthorizationStatusQuickInfo extends AutogenLayoutAuthorizationStatusQuickInfo {

    sourceAuthorizationStatusAfterExecution(event) {
        this.panelColorDisplay.backgroundColor = this.mainDataSource?.activeRow?.get("status_hex_color");
        this.panelColorDisplay.tooltip = this.mainDataSource?.activeRow?.get("status_hex_color");
    }

}
